import { runtimeConfig } from '@kiper/fns';
import cookie from 'js-cookie';

const types = {
  authorization: 'authorization',
  refresh: 'refresh',
  context: 'context',
  lastContext: 'lastContext',
  partnerContext: 'partnerContext',
  topNodeId: 'topNodeId',
  topContextId: 'topContextId',
  CloudFrontPolicy: 'CloudFrontPolicy',
  CloudFrontSignature: 'CloudFrontSignature',
  CloudFrontKeyPairId: 'CloudFrontKeyPairId',
};

const values = {
  [types.authorization]: 'kiper-authorization',
  [types.refresh]: 'kiper-refresh',
  [types.context]: 'kiper-context',
  [types.lastContext]: 'kiper-last-context',
  [types.partnerContext]: 'kiper-partner-context',
  [types.topNodeId]: 'kiper-top-node-id',
  [types.topContextId]: 'kiper-top-context-id',
  [types.CloudFrontPolicy]: 'CloudFront-Policy',
  [types.CloudFrontSignature]: 'CloudFront-Signature',
  [types.CloudFrontKeyPairId]: 'CloudFront-Key-Pair-Id',
};

/**
 * Resolve o domínio do cookie em runtime a partir do hostname atual.
 *
 * O mesmo bundle é servido em mais de um TLD (ex.: kiper.com.br e
 * porter.com.br). Um cookie com atributo Domain que não é sufixo do host
 * atual é descartado silenciosamente pelo browser (RFC 6265), então o
 * domínio não pode ser fixado em build: escolhemos, dentre os domínios
 * configurados em RAZZLE_COOKIE_DOMAINS (lista separada por vírgula),
 * aquele que casa com o hostname da página. Sem correspondência, mantém o
 * comportamento antigo via RAZZLE_COOKIE_DOMAIN.
 */
export const resolveCookieDomain = () => {
  const configuredDomains = (runtimeConfig.RAZZLE_COOKIE_DOMAINS || '')
    .split(',')
    .map(configuredDomain => configuredDomain.trim())
    .filter(Boolean);

  if (typeof window !== 'undefined' && window.location) {
    const { hostname } = window.location;
    const matchedDomain = configuredDomains.find(configuredDomain =>
      hostname.endsWith(configuredDomain),
    );
    if (matchedDomain) return matchedDomain;
  }

  return runtimeConfig.RAZZLE_COOKIE_DOMAIN;
};

const isArray = obj => Object.prototype.toString.call(obj) === '[object Array]';

export { types, values };

const check = type => {
  if (values[type]) return;
  throw new Error('invalid cookie type');
};

export const remove = type => {
  const fn = x => {
    check(x);
    cookie.remove(values[x], { domain: resolveCookieDomain() });
  };

  if (isArray(type)) type.forEach(x => fn(x));
  else fn(type);
};

export const set = (type, value) => {
  check(type);
  if (typeof value === 'undefined') return remove(type);

  cookie.set(values[type], value, {
    domain: resolveCookieDomain(),
    sameSite: 'None',
    secure: true,
  });
  return value;
};

export const setMap = map =>
  Object.keys(map).forEach(key => set(key, map[key]));

export const get = (type, request) => {
  const fn = x => {
    check(x);
    if (request && request.cookies && request.cookies[values[x]])
      return request.cookies[values[x]];

    return cookie.get(values[x]);
  };

  if (isArray(type)) {
    return type.map(x => fn(x));
  }

  return fn(type);
};
